<template>
  <div>
      <Head>
        <Title>{{ header.subTitle }}</Title>
        <Meta
            :content="category?.name ?? ''"
            name="description"
        />
      </Head>

    <section class="px-4 mx-auto block bg-neutral-100 lg:grid lg:grid-cols-6 lg:gap-8 lg:w-full xl:px-0 xl:grid-cols-5">
        <div class="lg:col-span-2 xl:col-span-1">
          <FilterOptions
              ref="searchRef"
              :predefined-category="category"
              @filter="filterResult"
              @searching="isSearching = true;"
          />
        </div>
        <div class="lg:col-span-4 lg:pr-8 xl:col-span-3 2xl:col-span-4 2xl:pr-16">
          <div>
            <Breadcrumb
                :title="header.subTitle"
            />
          </div>
          <ArticleList
              :articles="articles"
              :category-id="category?._id"
              :is-searching="isSearching"
              @sort="performSearch('sort')"
          />
          <Pagination
              v-model:page="page"
              :last-page="lastPage"
              @update:page="performSearch('pagination');"
          />
        </div>
      </section>
  </div>
</template>

<script setup lang="ts">
import type {Ref} from 'vue';
import ArticleList from '../../components/ArticleList.vue';
import FilterOptions from '../../components/FilterOptions.vue';
import {useFilterStore} from '~~/stores/filter';

type HeaderState = {
  title: string;
  subTitle: string;
  text: string;
};

type Category = {
  _id: string;
  name: string;
};

type CategoryQueryResult = {
  category?: Category | null;
};

type ArticleSearchResult = Record<string, unknown>;

const HARDCODED_CATEGORY_HEADER_TEXT_BY_ID: Readonly<Record<string, string>> = {
    86: 'Die Serie 4.0 Metall steht für <b>langlebige, wartungsarme und holzfreie Spielgeräte</b> für öffentliche Spielräume. Das modulare Baukastensystem ermöglicht <b>individuelle Planung, flexible Erweiterung und maximale Anpassungsfähigkeit.</b> Pulverbeschichtetes Aluminium und robuste HPL-Elemente sorgen für <b>hohe Beständigkeit gegenüber Witterung, intensiver Nutzung und Vandalismus.</b>',
};

const route = useRoute();
const isSearching = ref(false);
const searchRef = ref<InstanceType<typeof FilterOptions> | null>(null);
const {filters} = useFilterStore();
const categoryQuery = await useAsyncGql({
    operation: 'findCategory',
    variables: {id: '/api/categories/' + String(route.params.id)},
}, {
    watch: [() => route.params.id],
    immediate: true,
});

const categoryData = categoryQuery.data as Ref<CategoryQueryResult | null>;
const category = computed<Category | null>(() => categoryData.value?.category ?? null);
const categoryHeaderText = computed<string>(() => HARDCODED_CATEGORY_HEADER_TEXT_BY_ID[String(route.params.id)] ?? '');

const header = useState<HeaderState>(
    'header',
);

watchEffect(() => {
    header.value = {
        title: 'Kategorie',
        subTitle: category.value?.name ?? '',
        text: categoryHeaderText.value,
    };
});

const articles = ref<ArticleSearchResult[]>([]);
const lastPage = ref<number>(1);
const page = ref<number>(1);

function filterResult(list: ArticleSearchResult[]) {
    articles.value = list;

    lastPage.value = filters.lastPage;
    isSearching.value = false;
}

function performSearch(type: string) {
    searchRef.value?.performSearch?.({
        page: page.value,
    });
    // isSearching.value = true;
    if (type === 'pagination') {
        const element = searchRef.value?.$el as HTMLElement | undefined;
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 100,
                left: 0,
                behavior: 'smooth',
            });
        }
    }
}
</script>
